import Swiper from 'swiper';
import screenfull from 'screenfull';
import initialize_slides_from_dataset from './initialize_slides_from_dataset';

export default class Slider {
	constructor(container) {
		initialize_slides_from_dataset(container);

		new Swiper(container, {
			// https://github.com/nolimits4web/swiper/issues/2621#issuecomment-586414784
			loop: container.dataset.count > 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			watchOverflow: true
		});

		const fullscreen_exit = container.querySelector('.swiper-fullscreen-exit');

		container.querySelectorAll('.swiper-slide').forEach(
			slide => slide.addEventListener('click', () => {
				if (!fullscreen_exit.classList.contains('hidden')) return;

				screenfull.request(container);
				fullscreen_exit.classList.remove('hidden');
			})
		);

		fullscreen_exit.addEventListener('click', () => {
			screenfull.exit(container);
		});

		// screenfull.on is undefined on ios safari
		if (!screenfull.on) return;

		screenfull.on('change', () => {
			if (!screenfull.isFullscreen) {
				fullscreen_exit.classList.add('hidden');
			}
		});
	}
}
